import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertTriangle, X } from "lucide-react";
import { hasActiveSubscriptionAccess } from "@/utils/subscriptionUtils";
import { useState } from "react";

const SubscriptionBanner = () => {
  const { user, loading, subscriptionLoading } = useAuth();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  // Don't show banner if auth is loading, subscription check is loading, user has active subscription access, or banner is dismissed
  const hasActiveSubscription = hasActiveSubscriptionAccess(user);
  
  if (loading || subscriptionLoading || !user || hasActiveSubscription || dismissed) {
    return null;
  }

  const handleSignUp = () => {
    navigate('/subscription-select');
  };

  const handleDismiss = () => {
    setDismissed(true);
  };

  return (
    <div className="bg-whiskey-amber/10 border-l-4 border-whiskey-amber p-4 relative">
      <div className="flex items-start space-x-3">
        <AlertTriangle className="h-5 w-5 text-whiskey-amber flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <h4 className="text-sm font-semibold text-whiskey-dark">
            Unlock alerts and the current allocated list
          </h4>
          <p className="text-sm text-muted-foreground mt-1">
            Explore everything for free. Upgrade anytime to receive alert notifications and see the live monthly allocated items.
          </p>
          <div className="mt-3">
            <Button 
              onClick={handleSignUp}
              className="bg-whiskey-amber hover:bg-whiskey-amber/90 text-whiskey-dark text-sm px-4 py-2 h-auto"
            >
              Upgrade for Full Access
            </Button>
          </div>
        </div>
        <button
          onClick={handleDismiss}
          className="text-muted-foreground hover:text-foreground p-1"
          aria-label="Dismiss banner"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default SubscriptionBanner;